import React, { memo } from "react";
import styled from "styled-components/macro";
import {
  MdLocationOn,
  MdPhone,
  MdEmail,
  MdNotificationsActive,
} from "react-icons/md";
import {
  Container,
  defaultHorizontalMargin,
  DefaultText,
  blueGradient,
} from "theme/GlobalElements";

const InfoHeader = () => {
  return (
    <Nav>
      <InfoContainer>
        <InfoHeaderWrapper>
          <InnerContainer>
            <Info style={{ marginRight: "20px" }}>
              <MdPhone style={{ marginRight: "10px" }} color="white" />
              <DefaultText className="text-sm" color="white">
                <ContactLink
                  href="tel:+359894468805"
                  aria-label="Обадете се на +359 894 468 805"
                >
                  +359 894 468 805
                </ContactLink>{" "}
                <span aria-hidden="true">/</span>{" "}
                <ContactLink
                  href="tel:+359889269946"
                  aria-label="Обадете се на +359 889 269 946"
                >
                  +359 889 269 946
                </ContactLink>
              </DefaultText>
            </Info>
            {/* <Info>
              <MdPhone style={{ marginRight: "10px" }} color="white" />
              <DefaultText className="text-sm" color="white">
                +359 886 560 510
              </DefaultText>
            </Info> */}
          </InnerContainer>
          <InnerContainer>
            <Info style={{ marginRight: "20px" }}>
              <MdEmail style={{ marginRight: "10px" }} color="white" />
              <DefaultText className="text-sm" color="white">
                <ContactLink href="mailto:office@i-clima.com">
                  office@i-clima.com
                </ContactLink>
              </DefaultText>
            </Info>
            <Info>
              <MdNotificationsActive
                style={{ marginRight: "10px" }}
                color="white"
              />
              <DefaultText className="text-sm" color="white">
                Заявете безплатен оглед*
              </DefaultText>
            </Info>
          </InnerContainer>
        </InfoHeaderWrapper>
      </InfoContainer>
    </Nav>
  );
};
export default memo(InfoHeader);

const Nav = styled.div`
  ${blueGradient};
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  height: 42px;
  -webkit-box-shadow: inset 1px -9px 8px -8px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: inset 1px -9px 8px -8px rgba(0, 0, 0, 0.75);
  box-shadow: inset 1px -9px 8px -8px rgba(0, 0, 0, 0.75);
`;
const InfoContainer = styled(Container)`
  flex: 1;
`;

const InfoHeaderWrapper = styled.div`
  ${defaultHorizontalMargin};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 10px 0;
`;
const InnerContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const Info = styled.div`
  display: inline-flex;
  align-items: center;
`;

const ContactLink = styled.a`
  color: inherit;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }

  &:focus-visible {
    border-radius: 2px;
    outline: 2px solid currentColor;
    outline-offset: 2px;
  }
`;
